const formatPrice = num => `$${(num || 0) / 100}`;

export default formatPrice;